import {
  BannerModule,
  CssColsModule,
  DropdownModule,
  FlexboxModule,
  GridModule,
  IconModule,
  ImageModule,
  MediaBlockModule,
  MediaCardModule,
  PaddingModule,
  PanelModule,
  RiskFactorModule,
  SearchBarModule,
  SearchModule,
  SimpleModalModule,
  SpacingModule,
  TabsModule,
  TitleModule,
  VideoModule,
} from '@frk/eds-components';

import { AgGridModule } from '@ag-grid-community/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FundContentComponent } from './fund-content/fund-content.component';
import { FundContentService } from '@products/overview/services/fund-content.service';
import { FundInformationComponent } from './fund-information/fund-information.component';
import { FundInformationPanelComponent } from './fund-information/fund-information-panel/fund-information-panel.component';
import { FundManagementComponent } from './fund-management/fund-management.component';
import { FundManagementService } from './services/fund-management.service';
import { GridFilterGroupHeaderComponent } from './trading-information/grid-filter-group-header/grid-filter-group-header.component';
import { ManagerProfileComponent } from './manager-profile/manager-profile.component';
import { NgModule } from '@angular/core';
import { OverviewEntryComponent } from './overview-entry/overview-entry.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { SummaryService } from './services/summary.service';
import { TradingInformationComponent } from './trading-information/trading-information.component';
import { TradingInformationService } from './services/trading-information.service';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { AvatarBlockModule } from '@marketing/content-blocks/avatar-block/avatar-block.module';
import { AnalizyRatingComponent } from './analizy-rating/analizy-rating.component';
import { BlockQuoteBlockModule } from '@marketing/content-blocks/blockquote-block/blockquote-block.module';
import { ImageBlockModule } from '@marketing/content-blocks/image-block/image-block.module';
import { MediaCardGroupModule } from '@marketing/content-blocks/media-card-group/media-card-group.module';
import { ButtonsBlockModule } from '@marketing/content-blocks/buttons-block/buttons-block.module';
import { MediaCardBlockModule } from '@marketing/content-blocks/media-card-block/media-card-block.module';

@NgModule({
  imports: [
    CommonModule,
    CssColsModule,
    BlockQuoteBlockModule,
    AvatarBlockModule,
    RouterModule,
    FormsModule,
    SharedModule,
    // EDS Components
    BannerModule,
    TitleModule,
    IconModule,
    GridModule,
    ImageModule,
    MediaCardModule,
    MediaBlockModule,
    SpacingModule,
    TabsModule,
    RiskFactorModule,
    DropdownModule,
    SearchModule,
    SimpleModalModule,
    SearchBarModule,
    PanelModule,
    FlexboxModule,
    PaddingModule,
    VideoModule,
    ImageBlockModule,
    MediaCardGroupModule,
    ButtonsBlockModule,
    MediaCardBlockModule,
    AgGridModule.withComponents([GridFilterGroupHeaderComponent]),
  ],
  declarations: [
    OverviewEntryComponent,
    FundInformationComponent,
    FundContentComponent,
    FundManagementComponent,
    FundInformationPanelComponent,
    TradingInformationComponent,
    GridFilterGroupHeaderComponent,
    ManagerProfileComponent,
    AnalizyRatingComponent,
  ],
  entryComponents: [
    OverviewEntryComponent,
    FundInformationComponent,
    FundContentComponent,
    FundManagementComponent,
    ManagerProfileComponent,
  ],
  providers: [
    SummaryService,
    FundManagementService,
    FundContentService,
    TradingInformationService,
  ],
})
export class OverviewModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule]);
  }
}

export const overviewModuleComponentMapping = {
  'Fund Overview': OverviewEntryComponent,
  'Fund Content': OverviewEntryComponent,
};
